import { DetranPage } from './detran.page';
import { ReceiptDetranPage } from './receipt-detran/detran-receipt.page';
import { ConsultComponent } from './consult/consult.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentResumeDetran } from './payment-resume/payment-resume.component';
import { CarListComponent } from './car-list/car-list.component';


const routes: Routes = [


  {
    path: '',
    component: DetranPage,
    children: [
      {
        path: 'consult',
        component: ConsultComponent,
      },     
      {
        path: 'payment-resume-dentra',
        component: PaymentResumeDetran
      },
      {
        path: 'payment-receipt-detran',
        component: ReceiptDetranPage
      },
      {
        path: 'vehicle-list',
        component: CarListComponent
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DetranRoutingModule { }
